import {
  COACH_OFFER_REQUEST,
  COACH_OFFER_SUCCESS,
  COACH_SIGNUP_SUCCESS,
  SHOW_COACH_SIGNUP_MODAL,
  CLOSE_COACH_SIGNUP_MODAL
} from '../actions'

const defaultState = {
  offered: false,
  offerText: null,
  showSignUpModal: false,
  signUpComplete: false
}

export default function coach (state = defaultState, action) {
  switch (action.type) {
    case COACH_OFFER_REQUEST:
      return {
        ...state,
        offered: true
      }

    case COACH_OFFER_SUCCESS:
      return {
        ...state,
        offerText: action.payload.offer_text
      }

    // this includes successful signup cancellations
    case COACH_SIGNUP_SUCCESS:
      return {
        ...state,
        showSignUpModal: action.acceptedOffer,
        signUpComplete: true,
        offerText: null
      }
    case SHOW_COACH_SIGNUP_MODAL:
      return {
        ...state,
        showSignUpModal: true
      }

    case CLOSE_COACH_SIGNUP_MODAL:
      return {
        ...state,
        showSignUpModal: false
      }

    default:
      return state
  }
}
